import { Snowflake, Phone, MessageSquare, Mail, Clock, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY, BRANDS, SERVICE_AREAS } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";
import { onCallClick, onTextClick } from "@/lib/dialer";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="border-t border-white/5 bg-ink-900" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-14 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          {settings.logo ? (
            <img src={settings.logo} alt="AIR-COLD HVAC" className="h-14 w-auto rounded-md object-contain" data-testid="footer-logo"/>
          ) : (
            <div className="flex items-center gap-2.5" data-testid="footer-logo-fallback">
              <div className="size-10 rounded-xl bg-ice-400/15 grid place-items-center ring-1 ring-ice-400/40"><Snowflake className="size-5 text-ice-400"/></div>
              <div className="font-display font-black text-lg">AIR-COLD HVAC</div>
            </div>
          )}
          <p className="mt-4 text-sm text-silver-300 max-w-sm">Premium residential & commercial HVAC repair, installation, and maintenance across Southern California.</p>
          <div className="mt-5 grid gap-2 text-sm">
            <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="flex items-center gap-2 text-silver-300 hover:text-ice-400" data-testid="footer-phone"><Phone className="size-4"/> {COMPANY.phone}</a>
            <a href={COMPANY.sms} onClick={onTextClick} className="flex items-center gap-2 text-silver-300 hover:text-ice-400" data-testid="footer-text"><MessageSquare className="size-4"/> Text Us</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 text-silver-300 hover:text-ice-400"><Mail className="size-4"/> {COMPANY.email}</a>
            <div className="flex items-center gap-2 text-silver-400"><Clock className="size-4"/> Mon–Sun · 24/7 Emergency</div>
          </div>
          <div className="mt-5 flex gap-3">
            <a href="#" aria-label="Facebook" className="size-9 rounded-full bg-white/5 grid place-items-center hover:bg-white/10"><Facebook className="size-4"/></a>
            <a href="#" aria-label="Instagram" className="size-9 rounded-full bg-white/5 grid place-items-center hover:bg-white/10"><Instagram className="size-4"/></a>
            <a href="#" aria-label="LinkedIn" className="size-9 rounded-full bg-white/5 grid place-items-center hover:bg-white/10"><Linkedin className="size-4"/></a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-silver-400">Services</div>
          <ul className="mt-4 grid gap-2 text-sm text-silver-300">
            <li><Link to="/#services" className="hover:text-ice-400">AC Repair & Install</Link></li>
            <li><Link to="/#services" className="hover:text-ice-400">Furnace Service</Link></li>
            <li><Link to="/#services" className="hover:text-ice-400">Mini Splits</Link></li>
            <li><Link to="/#services" className="hover:text-ice-400">Commercial HVAC</Link></li>
            <li><Link to="/#services" className="hover:text-ice-400">Emergency HVAC</Link></li>
            <li><Link to="/schedule" className="hover:text-ice-400">Schedule Service</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-silver-400">Brands</div>
          <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-silver-300">
            {BRANDS.slice(0,10).map(b => <li key={b}>{b}</li>)}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-silver-400">Service Areas</div>
          <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-silver-300">
            {Object.values(SERVICE_AREAS).flat().slice(0,12).map(c => (
              <li key={c}><Link to={`/city/${encodeURIComponent(c.toLowerCase().replace(/ /g,"-"))}`} className="hover:text-ice-400">{c}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-silver-500" data-testid="footer-bottom">
        © {new Date().getFullYear()} AIR-COLD HVAC. Licensed & Insured. · <a href="#" className="hover:text-ice-400">Privacy</a> · <a href="#" className="hover:text-ice-400">Terms</a>
      </div>
    </footer>
  );
}
